class ClubWebsiteNotLiveException extends Error {
  constructor(message) {
    super(message);
    this.name = 'ClubWebsiteNotLiveException';
  }
}

export default ClubWebsiteNotLiveException;
